import { defineComponent as a, openBlock as d, createElementBlock as l, normalizeClass as e, renderSlot as i, createElementVNode as c, withModifiers as p, createVNode as u, unref as m } from "vue";
import { d as k } from "./ArrowIcon.GDkXwpPs.js";
import "./DownloadIcon.DHCHRETy.js";
const f = ["id"], g = ["aria-expanded", "aria-controls"], w = /* @__PURE__ */ a({
  inheritAttrs: !1,
  __name: "BaseAccordionBtn",
  props: {
    id: {},
    arrowWidth: { default: 12 },
    onContainerClickExpand: { type: Boolean, default: !1 },
    accordionOpen: { type: Boolean, default: !1 },
    toggleAccordion: {}
  },
  emits: ["click"],
  setup(h, { emit: n }) {
    const r = n;
    return (o, t) => (d(), l("div", {
      id: `${o.id}`,
      class: e(["uikit-flex uikit-items-center uikit-justify-around", [
        o.$attrs["btn-wrapper-classes"],
        o.onContainerClickExpand ? "uikit-cursor-pointer" : ""
      ]]),
      onClick: t[1] || (t[1] = (s) => o.onContainerClickExpand && o.toggleAccordion())
    }, [
      i(o.$slots, "custom_content"),
      i(o.$slots, "custom_btn", {
        btnId: `btn-${o.id}`,
        isOpen: o.accordionOpen,
        toggleAccordion: o.toggleAccordion
      }, () => [
        c("button", {
          type: "button",
          class: e(["uikit-border-0 uikit-bg-transparent", o.$attrs["btn-classes"]]),
          "aria-expanded": o.accordionOpen,
          "aria-controls": `accordion-text-${o.id}`,
          onClick: t[0] || (t[0] = p((s) => {
            o.toggleAccordion(), r("click");
          }, ["prevent", "stop"]))
        }, [
          u(m(k), {
            class: e([
              "uikit-transition-transform motion-reduce:uikit-transition-none",
              [
                o.accordionOpen ? "uikit-rotate-180" : "",
                o.$attrs["arrow-classes"]
              ]
            ]),
            width: o.arrowWidth,
            height: o.arrowWidth
          }, null, 8, ["class", "width", "height"])
        ], 10, g)
      ])
    ], 10, f));
  }
});
export {
  w as _
};
